import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from '../../styles/modules/mortgage/MortgageFAQItem.module.scss';

const MortgageFAQItem = ({ title, description }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleOnClick = (e) => {
    if (e.target.tagName === 'A') return;
    setIsExpanded(!isExpanded);
  };

  return (
    <div
      className={[styles.item, isExpanded && styles.active].filter(Boolean).join(' ')}
      onClick={handleOnClick}
    >
      <div className={styles.itemHeader}>
        {title}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <motion.line
            x1="12"
            y1="5"
            x2="12"
            y2="19"
            animate={{ rotate: isExpanded ? -90 : 0 }}
            transition={{ duration: 0.3 }}
          />
          <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
      </div>
      <AnimatePresence>
        {isExpanded && (
          <motion.div
            className={styles.itemBody}
            initial="collapsed"
            animate="expanded"
            exit="collapsed"
            variants={{
              expanded: { opacity: 1, height: 'auto' },
              collapsed: { opacity: 0, height: 0 }
            }}
            transition={{ duration: 0.5, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            {description.map((v, i) => (
              <div
                className={styles.itemBodyGroup}
                key={i}
                dangerouslySetInnerHTML={{ __html: v }}
              />
            ))}
            <div className={styles.itemBodyDummy} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default MortgageFAQItem;
